/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponUsageSummary } from './BaseCouponUsageSummary';
import { TenantAccessPlan } from './TenantAccessPlan';
const AccessPlanCouponUsageSummaryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['plan', TenantAccessPlan],
]), BaseCouponUsageSummary);
export class AccessPlanCouponUsageSummary extends BaseCouponUsageSummary {
    static decode(input) {
        return AccessPlanCouponUsageSummaryParser.decode(input).map(res => new AccessPlanCouponUsageSummary(res));
    }
    static unsafeDecode(input) {
        return AccessPlanCouponUsageSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessPlanCouponUsageSummaryParser.encode(data);
    }
    static schema() {
        return AccessPlanCouponUsageSummaryParser.schema();
    }
}
